import EventEmitter from 'wolfy87-eventemitter';

var createLoader = function createLoader(loader) {
  var getLibrary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var loading = false;
  var loaded = false;
  var events = new EventEmitter();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve) {
      var existingLibrary = getLibrary !== null ? getLibrary.apply(void 0, args) : null;

      if (loaded || existingLibrary !== null) {
        resolve(existingLibrary);
        return;
      }

      if (loading) {
        events.once('loaded', resolve);
        return;
      }

      loading = true;
      loader.apply(void 0, args).then(function () {
        var loadedLibrary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var library = loadedLibrary;

        if (library === null && getLibrary !== null) {
          library = getLibrary.apply(void 0, args);
        }

        loaded = true;
        resolve(library);
        events.emit('loaded', library);
      });
    });
  };
};

export default createLoader;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/createLoader.js
// module id = null
// module chunks = 